<template>
    <div>
        <Header/>
        <div class="step">
            <b-container>
                <b-row>
                    <b-col lg="6" class="align-self-center">
                        <b-row class="progress-mobile mb-5 mt-4">
                            <b-row>
                                <b-col cols="1">
                                    <router-link :to="{ name: 'step3'}"> <img src="../assets/img/icn_arrow_back_mobile.svg" alt="arrow icon"></router-link>
                                </b-col>
                                <b-col cols="11">
                                <ProgressBarMobile :percentage="80"/> 
                                </b-col>
                            
                            </b-row>
                        </b-row>
                        <b-row>
                            <b-col lg="12" class="mb-5">
                                <h3>AGREGA TUS REFERENCIAS</h3>
                                <p><strong>PASO 4.</strong> REFERENCIAS FAMILIARES</p>
                                <span>Sólo necesitas 3 referencias familiares por ejemplo: mamá, papá, hermanos, tíos, tías, etc.</span>
                            </b-col>
                            <b-form>
                                <b-row class="referencia-container">
                                    <p><strong>REFERENCIA 1</strong></p>
                                    <b-col lg="4">
                                        <b-form-group
                                            id="input-group-1"
                                            label="Nombre completo*"
                                            label-for="input-1"
                                            class="mb-2"
                                        >
                                            <b-form-input
                                            id="input-1"
                                            v-model="referencia1.name"
                                            placeholder="Nombre y Apellido(s)"
                                            :class="{'required':  (btnActive && referencia1.name=='')}"
                                            type="text"
                                            required
                                            ></b-form-input>
                                            <span class="required-label" :class="{'show': (btnActive && referencia1.name=='')}">Favor de ingresar datos</span>
                                        </b-form-group>
                                    </b-col>
                                    <b-col lg="4">
                                        <b-form-group id="input-group-2" label="Teléfono*" label-for="input-2" class="mb-2">
                                            <b-form-input
                                            id="input-2"
                                            v-model="referencia1.phone"
                                            :class="{'required':  (btnActive && referencia1.phone=='')}"
                                            placeholder="(___)"
                                            v-mask="'(###) ###-####'"
                                            type="tel"
                                            required
                                            ></b-form-input>
                                            <span class="required-label" :class="{'show': (btnActive && referencia1.phone=='')}">Favor de ingresar datos</span>
                                            <span class="required-label" :class="{'show': referencia1.phone.length<14 && referencia1.phone!=''}">El teléfono debe incluir 10 dígitos</span>
                                        </b-form-group>
                                    </b-col>
                                    <b-col lg="4">
                                        <b-form-group
                                            id="input-group-3"
                                            label="Relación*"
                                            label-for="input-3"
                                            class="mb-2"
                                        >
                                            <b-form-select
                                                id="input-3"
                                                v-model="referencia1.relationship"
                                                :options="referenciasOptions"
                                                placeholder="Referencia"
                                                :class="{'disable': null === referencia1.relationship, 'required':  (btnActive && referencia1.relationship==null)}"
                                            ></b-form-select>
                                            <b-form-input
                                                id="input-1"
                                                v-if="referencia1.relationship==4"
                                                v-model="referencia1.relationshipOther"
                                                placeholder="Ingresa referencia"
                                                :class="{'required':  (btnActive && referencia1.relationshipOther=='')}"
                                                type="text"
                                                class="mt-2"
                                                required
                                            ></b-form-input>   
                                            <span class="required-label" :class="{'show': (btnActive && referencia1.relationshipOther=='' && referencia1.relationship==4 )}">Favor de ingresar datos</span>
                                            <span class="required-label" :class="{'show': (btnActive && referencia1.relationship==null)}">Favor de ingresar datos</span>
                                        </b-form-group>
                                    </b-col>
                                </b-row>

                                <b-row class="referencia-container">
                                    <p><strong>REFERENCIA 2</strong></p>
                                    <b-col lg="4">
                                        <b-form-group
                                            id="input-group-4"
                                            label="Nombre completo*"
                                            label-for="input-4"
                                            class="mb-2"
                                        >
                                            <b-form-input
                                            id="input-4"
                                            v-model="referencia2.name"
                                            :class="{'required':  (btnActive && referencia2.name=='')}"
                                            placeholder="Nombre y Apellido(s)"
                                            type="text"
                                            required
                                            ></b-form-input>
                                            <span class="required-label" :class="{'show': (btnActive && referencia2.name=='')}">Favor de ingresar datos</span>
                                        </b-form-group>
                                    </b-col>
                                    <b-col lg="4">
                                        <b-form-group id="input-group-5" label="Teléfono*" label-for="input-5" class="mb-2">
                                            <b-form-input
                                            id="input-5"
                                            v-model="referencia2.phone"
                                            :class="{'required':  (btnActive && referencia2.phone=='')}"
                                            placeholder="(___)"
                                            v-mask="'(###) ###-####'"
                                            type="tel"
                                            required
                                            ></b-form-input>
                                            <span class="required-label" :class="{'show': (btnActive && referencia2.phone=='')}">Favor de ingresar datos</span>
                                            <span class="required-label" :class="{'show': referencia2.phone.length<14 && referencia2.phone!=''}">El teléfono debe incluir 10 dígitos</span>
                                        </b-form-group>
                                    </b-col>
                                    <b-col lg="4">
                                        <b-form-group
                                            id="input-group-6"
                                            label="Relación*"
                                            label-for="input-6"
                                            class="mb-2"
                                        >
                                            <b-form-select
                                                id="input-3"
                                                v-model="referencia2.relationship"
                                                :options="referenciasOptions"
                                                placeholder="Referencia"
                                                :class="{'disable': null === referencia2.relationship, 'required':  (btnActive && referencia2.relationship==null)}"
                                            ></b-form-select> 
                                            <b-form-input
                                                id="input-1"
                                                v-if="referencia2.relationship==4"
                                                v-model="referencia2.relationshipOther"
                                                placeholder="Ingresa referencia"
                                                :class="{'required':  (btnActive && referencia2.relationshipOther=='')}"
                                                type="text"
                                                class="mt-2"
                                                required
                                            ></b-form-input>   
                                            <span class="required-label" :class="{'show': (btnActive && referencia2.relationshipOther=='' && referencia2.relationship==4)}">Favor de ingresar datos</span>
                                            <span class="required-label" :class="{'show': (btnActive && referencia2.relationship==null)}">Favor de ingresar datos</span>
                                        </b-form-group>
                                    </b-col>
                                </b-row>

                                <b-row class="referencia-container">
                                    <p><strong>REFERENCIA 3</strong></p>
                                    <b-col lg="4">
                                        <b-form-group
                                            id="input-group-7"
                                            label="Nombre completo*"
                                            label-for="input-7"
                                            class="mb-2"
                                        >
                                            <b-form-input
                                            id="input-7"
                                            v-model="referencia3.name"
                                            :class="{'required':  (btnActive && referencia3.name=='')}"
                                            placeholder="Nombre y Apellido(s)"
                                            type="text"
                                            required
                                            ></b-form-input>
                                            <span class="required-label" :class="{'show': (btnActive && referencia3.name=='')}">Favor de ingresar datos</span>
                                        </b-form-group>
                                    </b-col>
                                    <b-col lg="4">
                                        <b-form-group id="input-group-8" label="Teléfono*" label-for="input-8" class="mb-2">
                                            <b-form-input
                                            id="input-8"
                                            v-model="referencia3.phone"
                                            :class="{'required':  (btnActive && referencia3.phone=='')}"
                                            placeholder="(___)"
                                            v-mask="'(###) ###-####'"
                                            type="tel"
                                            required
                                            ></b-form-input>
                                            <span class="required-label" :class="{'show': (btnActive && referencia3.phone=='')}">Favor de ingresar datos</span>
                                            <span class="required-label" :class="{'show': referencia3.phone.length<14 && referencia3.phone!=''}">El teléfono debe incluir 10 dígitos</span>
                                        </b-form-group>
                                    </b-col>
                                    <b-col lg="4">
                                        <b-form-group
                                            id="input-group-9"
                                            label="Relación*"
                                            label-for="input-9"
                                            class="mb-2"
                                        >
                                            <b-form-select
                                                id="input-3"
                                                v-model="referencia3.relationship"
                                                :options="referenciasOptions"
                                                placeholder="Referencia"
                                                :class="{'disable': null === referencia3.relationship, 'required':  (btnActive && referencia3.relationship==null)}"
                                            ></b-form-select> 
                                            <b-form-input
                                                id="input-1"
                                                v-if="referencia3.relationship==4"
                                                v-model="referencia3.relationshipOther"
                                                placeholder="Ingresa referencia"
                                                :class="{'required':  (btnActive && referencia3.relationshipOther=='')}"
                                                type="text"
                                                class="mt-2"
                                                required
                                            ></b-form-input>   
                                            <span class="required-label" :class="{'show': (btnActive && referencia3.relationshipOther=='' && referencia3.relationship==4)}">Favor de ingresar datos</span>
                                            <span class="required-label" :class="{'show': (btnActive && referencia3.relationship==null)}">Favor de ingresar datos</span>
                                        </b-form-group>
                                    </b-col>
                                </b-row>




                                <div v-if="showAdicional">
                                    <h3>TARJETA ADICIONAL</h3>
                                    <p v-if="income<4000" class="msg-income">Necesitas registrar una tarjeta adicional para continuar con tu proceso</p>
                                    <p>DATOS PERSONALES DE TU TARJETA ADICIONAL</p>

                                    <b-row class="mb-5 mt-2">
                                        <b-col lg="6">
                                            <b-form-group
                                                id="input-group-2-1"
                                                label="Nombre(s)*"
                                                label-for="input-2-1"
                                                class="mb-4"
                                            >
                                                <b-form-input
                                                id="input-2-1"
                                                v-model="adicional.name"
                                                placeholder="Ingresa tu nombre(s)"
                                                type="text"
                                                ></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="6">
                                            <b-form-group
                                                id="input-group-2-3"
                                                label="Apellido Paterno*"
                                                label-for="input-2-3"
                                                class="mb-4"
                                            >
                                                <b-form-input
                                                id="input-2-3"
                                                v-model="adicional.lastname1"
                                                placeholder="Ingresa tu apellido parteno"
                                                type="text"
                                                ></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="6">
                                            <b-form-group
                                                id="input-group-2-2"
                                                label="Apellido Materno*"
                                                label-for="input-2-2"
                                                class="mb-4"
                                            >
                                                <b-form-input
                                                id="input-2-2"
                                                v-model="adicional.lastname2"
                                                placeholder="Ingresa tu apellido materno"
                                                type="text"
                                                ></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="6">
                                            <b-form-group
                                                id="input-group-2-4"
                                                label="Fecha de nacimiento*"
                                                label-for="input-2-4"
                                                class="mb-4"
                                            >
                                                <date-picker 
                                                    v-model="adicional.birthday" 
                                                    format="DD/MM/YYYY" 
                                                    placeholder="DD / MM / AAAA"
                                                    :lang="es"
                                                    v-mask="'##/##/####'"
                                                    class="date-picker-input form-control"
                                                    :class="{'disable': '' === adicional.birthday, 'required':  (btnActive && (adicional.birthday=='' || adicional.birthday==null))}">
                                                </date-picker>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="6">
                                            <b-form-group
                                                id="input-group-2-5"
                                                label="Relación*"
                                                label-for="input-2-5"
                                                class="mb-2"
                                            >
                                                <b-form-select
                                                id="input-2-5"
                                                v-model="adicional.relationship"
                                                :options="relationshipOptions"
                                                placeholder="Ingresa tu apellido materno"
                                                :class="{'disable': null === adicional.relationship}"
                                                ></b-form-select>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>

                                    <p>DATOS DE TRABAJO DE TU TARJETA ADICIONAL</p>

                                    <b-row class="mt-2">
                                        <b-col lg="6">
                                            <b-form-group
                                                id="input-group-2-6"
                                                label="Lugar de trabajo*"
                                                label-for="input-2-6"
                                                class="mb-4"
                                            >
                                                <b-form-input
                                                id="input-2-6"
                                                v-model="adicional.job"
                                                placeholder="Nombre de la empresa"
                                                type="text"
                                                ></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="6">
                                            <b-form-group
                                                id="input-group-2-7"
                                                label="Puesto*"
                                                label-for="input-2-7"
                                                class="mb-4"
                                            >
                                                <b-form-input
                                                id="input-2-7"
                                                v-model="adicional.jobPosition"
                                                placeholder="Nombre de tu puesto"
                                                type="text"
                                                ></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="6">
                                            <b-form-group
                                                id="input-group-2-8"
                                                label="Salario mensual*"
                                                label-for="input-2-8"
                                                class="mb-4 currencyContainer"
                                            >
                                                <b-form-input
                                                id="input-2-8"
                                                v-model="adicional.income"
                                                v-mask="currencyMask"
                                                type="text"
                                                ></b-form-input>
                                            <span class="money">$</span>
                                            <div class="line"></div>
                                            <b-form-radio-group
                                                    id="btn-radios-1"
                                                    v-model="adicional.currency"
                                                    :options="currencyOptions"
                                                    :aria-describedby="ariaDescribedby"
                                                    name="radios-btn-default"
                                                    class="currencyBtn"
                                                    buttons
                                                ></b-form-radio-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="6">
                                            <b-form-group
                                                id="input-group-2-9"
                                                label="Antigüedad laboral*"
                                                label-for="input-2-9"
                                                class="mb-4"
                                            >
                                                <b-form-select
                                                    id="input-4"
                                                    v-model="adicional.yearsWorking"
                                                    :options="yearsOptions"
                                                    :class="{'disable': null === adicional.yearsWorking}"

                                                ></b-form-select>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="6">
                                            <b-form-group
                                                id="input-group-2-10"
                                                label="Teléfono de trabajo*"
                                                label-for="input-2-10"
                                                class="mb-4"
                                            >
                                                <b-form-input
                                                id="input-2-10"
                                                v-model="adicional.phoneJob"
                                                v-mask="'(###) ###-####'"
                                                placeholder="Ingresa el teléfono de tu trabajo"
                                                type="text"
                                                ></b-form-input>
                                                <span class="required-label" :class="{'show': adicional.phoneJob.length<14 && adicional.phoneJob!=''}">El teléfono debe incluir 10 dígitos</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="3">
                                            <b-form-group
                                                id="input-group-2-11"
                                                label="Ext"
                                                label-for="input-2-11"
                                                class="mb-4"
                                            >
                                                <b-form-input
                                                id="input-2-11"
                                                v-model="adicional.ext"
                                                placeholder="___"
                                                type="text"
                                                ></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </div>
                                
                                <b-row>
                                    <p class="text-aditional mb-4" v-if="showAdicional && income>4000">No quieres tramitar una <span>Tarjeta Adicional, regresa <span class="show-aditional" @click="showAdicional = false">aquí</span></span></p>    
                                    <p class="text-aditional mb-4" v-if="!showAdicional && income>4000" >¿Quieres agregar a alguien más a tu cuenta? Solicita una <span>Tarjeta Adicional <span class="show-aditional"  @click="showAdicional = true">aquí</span></span></p>    
                                    
                                    <b-col xl="2" lg="3" md="4" class="back-desktop">
                                        <router-link class="btn-back" :to="{ name: 'step3'}"> <img src="../assets/img/icn_arrow_back.svg" alt="arrow icon"> Regresa</router-link>
                                    </b-col>
                                    <b-col lg="6">
                                        <b-button v-on:click.stop="nextStep"  class="btn-next mb-2">Continuar</b-button>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </b-row>
                    </b-col>
                    <b-col lg="6" class="step-progress-bar">
                        <ProgressBar :percentage="80" :image="image"  />
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import ProgressBar from '../components/ProgressStep.vue'
    import ProgressBarMobile from '../components/ProgressStepMobile.vue'
    import Header from '../components/Header.vue'
    import axios from 'axios'
    import createNumberMask from "text-mask-addons/dist/createNumberMask"
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'  
    import es from 'vue2-datepicker/locale/es'

    export default {
        created (){
            this.income = parseInt(sessionStorage.getItem('applicant_work_monthly_income'))
            this.currency = sessionStorage.getItem('applicant_work_currency')
            this.income = this.currency==1 ? this.income * 18 : this.income
            this.showAdicional = this.income > 4000 ? false : true
        },
        data() {
            return {
                btnActive: false,
                income: '',
                currency: '',
                image: require('./../assets/img/img_paso4.png'),
                referencia1: {
                    name: '',
                    phone: '',
                    relationship: null,
                    relationshipOther: '' 
                },
                referencia2: {
                    name: '',
                    phone: '',
                    relationship: null,
                    relationshipOther: ''
                },
                referencia3: {
                    name: '',
                    phone: '',
                    relationship: null,
                    relationshipOther: ''
                },
                showAdicional: false,
                adicional: {
                    name: '',
                    lastname1: '',
                    lastname2: '',
                    birthday: '',
                    relationship: null,
                    job: '',
                    jobPosition: '',
                    income: 0,
                    currency: 0,
                    yearsWorking: null,
                    phoneJob: '',
                    ext: ''
                },
                currencyMask: createNumberMask({
                    prefix: "",
                    includeThousandsSeparator: true,
                    allowNegative: false,
                    thousandsSeparatorSymbol: ",",
                }),
                yearsOptions: [
                    { text: '¿Cuánto tiempo llevas en tu empresa?', value: null, disabled: true },
                    { text: '1 año o menos', value: '1' },
                    { text: '1 - 2 años', value: '2' },
                    { text: '3 - 4 años', value: '3' },
                    { text: '5 o mas años', value: '4' },
                ],
                currencyOptions: [
                    { text: 'dlls', value: 1 },
                    { text: 'mxn', value: 0 },
                ],
                relationshipOptions: [
                    { text: 'Selecciona una opcion', value: null, disabled: true }, 
                    { text: 'Esposo(a)', value: 0 }, 
                    { text: 'Familiar', value: 1 }, 
                    { text: 'Amigo(a)', value: 2 }],
                referenciasOptions: [
                    { text: 'Selecciona una opcion', value: null, disabled: true }, 
                    { text: 'Padres', value: 1 }, 
                    { text: 'Hermanos', value: 2 }, 
                    { text: 'Familiares', value: 3 }, 
                    { text: 'Otro', value: 4 }],
            }
        },
        components: {
            ProgressBar,
            ProgressBarMobile,
            Header,
            DatePicker
        },
        methods: {
            nextStep() {
                let formData = new FormData()
                this.btnActive = true
                var email = sessionStorage.getItem('applicant_email')
                if(this.referencia1.name && this.referencia1.phone && this.referencia1.relationship && this.referencia2.name && this.referencia2.phone && this.referencia2.relationship && this.referencia3.name && this.referencia3.phone && this.referencia3.relationship) {
                    formData.append('step', 4)
                    formData.append('applicant_email', email)
                    formData.append('personal_reference_0_name', this.referencia1.name)
                    formData.append('personal_reference_0_phone', this.referencia1.phone)
                    formData.append('personal_reference_0_relation', this.referencia1.relationship == 4 ? this.referencia1.relationshipOther : this.referencia1.relationship)
                    formData.append('personal_reference_1_name', this.referencia2.name)
                    formData.append('personal_reference_1_phone', this.referencia2.phone)
                    formData.append('personal_reference_1_relation', this.referencia2.relationship == 4 ? this.referencia2.relationshipOther : this.referencia2.relationship)
                    formData.append('personal_reference_2_name', this.referencia3.name)
                    formData.append('personal_reference_2_phone', this.referencia3.phone)
                    formData.append('personal_reference_2_relation', this.referencia3.relationship == 4 ? this.referencia3.relationshipOther : this.referencia3.relationship)
                    if(this.showAdicional) {
                        formData.append('co_applicant_name', this.adicional.name)
                        formData.append('co_applicant_first_lastname', this.adicional.lastname1)
                        formData.append('co_applicant_second_lastname', this.adicional.lastname2)
                        formData.append('co_applicant_birthday_full_date', this.adicional.birthday)
                        formData.append('co_applicant_relation', this.adicional.relationship)
                        formData.append('co_applicant_work_place', this.adicional.job)
                        formData.append('co_applicant_work_position', this.adicional.jobPosition)
                        formData.append('co_applicant_work_monthly_income', this.adicional.income)
                        formData.append('co_applicant_work_currency', this.adicional.currency)
                        formData.append('co_applicant_work_since_full_date', this.adicional.yearsWorking)
                        formData.append('co_applicant_work_phone', this.adicional.phoneJob)
                        formData.append('co_phone_ext', this.adicional.ext)
                    }
                    axios
                    .post(
                        'https://apply.garlans.com/private/helpers/application_submit_api.php',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        },
                    )
                    .then((response) => {
                        if (!response.data.status) {        
                            this.$router.push('/paso-5')
                        } else {
                            console.log(response)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
                }
            }
        }
    }
</script>

<style scoped>
.step{
    padding: 3% 0;
    text-align: left;
}
h3{
    font-weight: bold;
}
p{
    font-weight: 500;
    margin-bottom: 0;
}
span{
    font-size: 13px;
}
.msg-income{
    font-size: 15px;
    margin-bottom: 20px;
}
.txt_min{
    width: 50%;
}
.currencyContainer .form-control{
    padding-left:2rem;
    padding-right:3rem;
}
.money{
    position: absolute;
    bottom: 7px;
    left: 10px;
    color: rgba(0, 0, 0, 0.3);
}
.line{
    position: absolute;
    bottom: 7px;
    width: 60%;
    height: 1px;
    left: 30px;
    background: rgba(0, 0, 0, 0.3);
}
label{
    margin-bottom: 10px;
}
.progress-mobile{
    display: none;
}
.referencia-container{
    background: rgba(0,0,0,0.02);
    padding: 15px 0;
    margin-bottom: 20px;
}
.custom-select{
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #000;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 0;
}
.disable.custom-select{
  color: rgba(0, 0, 0, 0.3) !important;
  background-color: transparent;
}
.custom-select:focus{
    color: #000;
    background-color: #fff;
    border-color: #000;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
}
.form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #000;
    background-color: transparent;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 0;
}
.form-control::placeholder{
    color: rgba(0, 0, 0, 0.3);
}
.form-control:focus {
    color: #000;
    background-color: #fff;
    border-color: #000;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
}

.form-control:focus::placeholder{
    color: transparent;
}
.btn-next,
.btn-next:hover,
.btn-next:focus{
    border-radius: 0;
    color: #fff;
    background: #000;
    width: 100%;
    text-align: center;
    font-weight: bold;
}
.currencyContainer{
    position: relative;
}
.currencyBtn{
    position: absolute;
    right: 10px;
    bottom: 6px;
}
.text-aditional{
    font-weight: 500;
    font-size: 18px;
}
.text-aditional span{
    font-size: 18px;
    font-weight: bold;
}
.show-aditional{
    color: #AF00B1;
    text-decoration: underline;
}
.show-aditional:hover{
    cursor: pointer;
}
.step-progress-bar{
    padding-left: 10%;
    padding-right: 5%;
}
.required-label{
    color: #D85067;
    font-size: 10px;
    position: absolute;
    display: none;
}
.show.required-label{
    display: block;
}
@media (max-width: 1600px) {
    .text-aditional,
    .text-aditional span{
        font-size: 13px;
    }
    .money{
        bottom: 5px;
    }
    .currencyBtn{
        position: absolute;
        right: 10px;
        bottom: 4px;
    }
    .line{
        width: 50%;
    }
    .currencyContainer .form-control{
        padding-left:2rem;
        padding-right:8rem;
    }
}
@media (max-width: 1400px) {
    .line{
        width: 40%;
    }
}
@media (max-width: 1200px) {
    .line{
        width: 35%;
    }
}
@media (max-width: 991px) {
    .line{
        width: 55%;
    }
}
@media (max-width: 768px) {
    .step{
        padding: 5%;
    }
    .txt_min{
        width: 100%;
    }
    .btn-next,
    .btn-next:hover,
    .btn-next:focus{
        font-size: 15px;
    }
    .back-desktop,
    .step-progress-bar{
        display: none;
    }
    .form-control,
    .custom-select {
        padding: 0.75rem;
    }
    .progress-mobile{
        display: block;
    }
    .currencyBtn{
        position: absolute;
        right: 10px;
        bottom: 10px;
    }
    .money{
        bottom: 10px;
    }
    .line{
        width: 50%;
        bottom: 11px;
    }
    .currencyContainer .form-control{
        padding-left:2rem;
        padding-right:8rem;
    }
}
</style>